'use strict'

/* global google, cf */

/**
 * @module tips
 */

import { addScript, getLang } from '../utils/utils'
import { throttle } from 'lodash'

const CLASS_IDENT = 'js-ident-camping'
const CLASS_MAP_ANCHOR = 'js-anchor-map'

const ID_MAP = 'js-camping-map'

const ATTRIBUTE_ID = 'data-campsite-id'
const ATTRIBUTE_MAP = 'data-map'

const SELECTOR_CONTACT = '.affichage_coordonnee'

const API_CAMPSITE = `${getLang()}/api/campsite/map/`

const SCRIPT_GOOGLE_MAP = 'https://maps.googleapis.com/maps/api/js?'
                          + 'key=' + cf.gmaps.key
                          + '&callback=initMap'
const ZOOM_LEVEL = 16

let listenToScroll = false

export default {
  /**
   * @description Initialise campingMap
   * @returns {undefined}
   */
  init() {
    this.mapContainer = document.getElementById(ID_MAP)
    if (this.mapContainer.offset().top - window.innerHeight - 200 > 0) {
      if (!listenToScroll) {
        this.scroll = throttle(() => {
          this.init()
        }, 100).bind(this)
        this.watchScroll()
      }
    } else {
      window.removeEventListener('scroll', this.scroll)
      fetch(API_CAMPSITE
            + document.getElementsByClassName(CLASS_IDENT).item(0).getAttribute(ATTRIBUTE_ID),
        { method: 'get' }
      ).then(response => {
        return response.text()
      }).then(response => {
        document.getElementById('js-camping-map-info').innerHTML = response
        document.getElementById('js-camping-map-info')
                .bindEvent('click', SELECTOR_CONTACT, this.displayContact)
        document.getElementById('js-camping-map-info').style.display = 'block'
      })
      document.getElementById('js-camping-map-button')
              .addEventListener('click', () => addScript(SCRIPT_GOOGLE_MAP))
    }
  },

  watchScroll() {
    if (listenToScroll) {
      return
    }
    listenToScroll = true
    window.addEventListener('scroll', this.scroll)
  },

  /**
   * @description Create map and marker
   * @returns {undefined}
   */
  initMap() {
    let mapData = this.mapContainer.getAttribute(ATTRIBUTE_MAP)
    if (typeof mapData === 'string') {
      mapData = JSON.parse(mapData)
    }

    this.map = new google.maps.Map(this.mapContainer, {
      zoom: ZOOM_LEVEL,
      center: mapData
    })
    this.marker = new google.maps.Marker({
      position: mapData,
      map: this.map
    })
    this.getInfo()
    this.bind()
  },

  /**
   * @description Bind click on marker
   * @returns {undefined}
   */
  bind() {
    google.maps.event.addListener(this.marker, 'click', this.openInfoWindow.bind(this))
    this.mapContainer.bindEvent('click', SELECTOR_CONTACT, this.displayContact)
    document.getElementsByClassName(CLASS_MAP_ANCHOR)
            .bindEvent('click', this.openInfoWindow.bind(this))
  },

  displayContact(e) {
    const elem = e.customCurrentTarget
    const links = elem.parentElement.getElementsByClassName('display-number')
    links[0].style.display = 'none'
    links[links.length -1].style.display = 'block'
  },

  /**
   * @description Fetch campsite html InfoWindow
   * @returns {undefined}
   */
  getInfo() {
    fetch(API_CAMPSITE
          + document.getElementsByClassName(CLASS_IDENT).item(0).getAttribute(ATTRIBUTE_ID),
          { method: 'get' }
    ).then(response => {
      return response.text()
    }).then(response => {
      this.displayInfoWindow(response)
    })
  },

  /**
   * @description Create InfoWindow
   * @params {string} html InfoWindow content
   * @returns {undefined}
   */
  displayInfoWindow(html) {
    this.infowindow = new google.maps.InfoWindow({
      content: html
    })
    this.openInfoWindow()
  },

  /**
   * @description Open InfoWindow
   * @returns {undefined}
   */
  openInfoWindow() {
    if (this.infowindow) {
      this.infowindow.open(this.map, this.marker)
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/campingMap.js